/* Giriş ekranı.

   Form `<form>` olarak kuruluyor, düğme dinleyicisi olarak değil: Enter tuşu,
   şifre yöneticileri ve tarayıcının kendi doğrulaması bedavaya gelsin.

   Sunucunun alan bazlı hataları (`fields`) doğrudan alanların altına
   basılıyor. İstemcinin kendi hata metnini uydurması, iki yerde tutulan ve
   zamanla ayrışan bir kural demekti — kurallar `packages/shared`'da
   (`adminLoginInput`). */

import { ApiError, auth } from '../api.ts';
import { el, replace } from '../dom.ts';

export type LoginOptions = {
  message?: string | undefined;
  onSuccess: (email: string) => void;
};

export function renderLogin(host: HTMLElement, opts: LoginOptions): void {
  const emailErr = el('p', { class: 'err' });
  const passErr = el('p', { class: 'err' });
  const formErr = el('p', { class: 'err', text: opts.message ?? '' });

  const email = el('input', {
    type: 'email',
    name: 'email',
    autocomplete: 'username',
    required: true,
    autofocus: true
  });
  const password = el('input', {
    type: 'password',
    name: 'password',
    autocomplete: 'current-password',
    required: true
  });
  /* TOTP alanı her zaman duruyor ama boşken hiç gönderilmiyor: hesapta TOTP
     açık mı, panel bunu giriş denemeden bilemiyor ve öğrenmek için ayrı bir
     uç açmak kullanıcı sayımına kapı aralardı. */
  const totp = el('input', {
    type: 'text',
    name: 'totp',
    inputmode: 'numeric',
    autocomplete: 'one-time-code',
    pattern: '\\d{6}',
    placeholder: 'TOTP açıksa'
  });

  const submit = el('button', { type: 'submit', class: 'primary', text: 'Giriş' });

  const form = el(
    'form',
    {
      onsubmit: async (event: Event) => {
        event.preventDefault();
        emailErr.textContent = '';
        passErr.textContent = '';
        formErr.textContent = '';
        submit.disabled = true;
        submit.textContent = 'Giriş yapılıyor…';

        try {
          await auth.login(email.value.trim(), password.value, totp.value.trim() || undefined);
          opts.onSuccess(email.value.trim().toLowerCase());
        } catch (err) {
          if (err instanceof ApiError) {
            emailErr.textContent = err.fields['email'] ?? '';
            passErr.textContent = err.fields['password'] ?? err.fields['totp'] ?? '';
            /* Alan bazlı hata yoksa genel mesaj gösterilir. Sunucu "e-posta ya
               da şifre hatalı" diyor ve hangisi olduğunu **söylemiyor** —
               kullanıcı sayımını engelleyen o kural burada da korunuyor. */
            if (!emailErr.textContent && !passErr.textContent) formErr.textContent = err.message;
          } else {
            formErr.textContent = 'Beklenmeyen bir hata oluştu.';
          }
          submit.disabled = false;
          submit.textContent = 'Giriş';
        }
      }
    },
    el('h1', { text: 'Yönetim' }),
    el('label', {}, el('span', { text: 'E-posta' }), email),
    emailErr,
    el('label', {}, el('span', { text: 'Şifre' }), password),
    passErr,
    el('label', {}, el('span', { text: 'Tek kullanımlık kod' }), totp),
    formErr,
    el('div', { class: 'row' }, submit)
  );

  replace(host, el('div', { class: 'login' }, form));
  email.focus();
}
